import { render } from "./AlertCheck.vue?vue&type=template&id=54e63cd0"
import script from "./AlertCheck.vue?vue&type=script&lang=js"
export * from "./AlertCheck.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__